import { pickerCurrentTime } from "@9amhealth/shared";
import type { ZonedDateTime } from "@internationalized/date";
import { DateFormats, dateLocal } from "src/lib/date";
import leftPadNumber from "src/lib/leftPadNumber";

/**
 * Converts the component's internal ISO (`YYYY-MM-DD`) date string into a
 * `ZonedDateTime` for use as the wheel picker's `initialDate`. Falls back to
 * "now" when the input is missing or doesn't parse to a valid date.
 */
export const isoDateToWheelDate = (isoDate?: string): ZonedDateTime => {
  const parsed = isoDate ? dateLocal(isoDate, DateFormats.ISO_YMD) : undefined;

  if (!parsed?.isValid()) {
    return pickerCurrentTime();
  }

  return pickerCurrentTime().set({
    year: parsed.year(),
    month: parsed.month() + 1,
    day: parsed.date()
  });
};

/**
 * Converts a `ZonedDateTime` from the wheel picker back into the component's
 * internal ISO (`YYYY-MM-DD`) date string.
 */
export const wheelDateToIsoDate = (date: ZonedDateTime): string => {
  return `${date.year}-${leftPadNumber(date.month)}-${leftPadNumber(date.day)}`;
};
